import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
const Annexure = ({label_annexure}) => {
  return (
    <div id='div_annexure'>{label_annexure}</div>
  )
}

export default Annexure